export const resultRoleJudge = (resultMarks1, resultMarks2) => {
  switch (true) {
    case resultMarks1 <= 8 || resultMarks1 === 1000:
      return "智囊團"
      break
    case resultMarks1 === 10:
      return "實踐者"
      break
    case resultMarks1 === 12:
      return "牽成者"
      break
    case resultMarks1 >= 14 && resultMarks1 < 9000:
      return "拓荒者"
      break
    default:
      return "鼓吹者"
      break
  }
}

export const getTraitId = role => {
  switch (role) {
    case "智囊團":
      return "thinktank"
    case "實踐者":
      return "adopters"
    case "牽成者":
      return "facilitators"
    case "拓荒者":
      return "movers"
    case "鼓吹者":
      return "advocates"

    default:
      return "11"
  }
}

export const QuestionsData = [
  {
    number: 1,
    question: "先認識你！請問年齡區間？",
    type: "word",
    answers: [
      { count1: 0, count2: 0, content: "24歲以下" },
      { count1: 0, count2: 0, content: "25~35歲" },
      { count1: 0, count2: 0, content: "36~49歲" },
      { count1: 0, count2: 0, content: "50歲以上" }
    ]
  },
  {
    number: 2,
    question: "請問你在地球上的性別？",
    type: "word",
    answers: [
      {
        count1: 0,
        count2: 0,
        content: "生理男"
      },
      {
        count1: 0,
        count2: 0,
        content: "生理女"
      },
      {
        count1: 0,
        count2: 0,
        content: "其他"
      }
    ]
  },
  {
    number: 3,
    question: "你最欣賞地球上的哪些人？",
    type: "word",
    answers: [
      { count1: 1000, count2: 0, content: "創新實踐家，如賈伯斯、伊隆·馬斯克" },
      { count1: 0, count2: 0, content: "專注本業的企業家，如比爾蓋茲、張忠謀" },
      { count1: 0, count2: 0, content: "打動人心的設計師，如宮崎駿、聶永真" },
      {
        count1: 10000,
        count2: 0,
        content: "社會公益推動者，如史蒂芬·柯瑞、劉安婷"
      }
    ]
  },

  {
    number: 4,
    question: "檢查裝備，準備出發！你對區塊鏈、Web3有多少認識？",
    type: "word",
    answers: [
      { count1: 0, count2: 0, content: "聽過幾個名詞吧？還沒實際體驗" },
      { count1: 4, count2: 0, content: "只領過免費NFT，搞不清楚如何買賣" },
      { count1: 6, count2: 0, content: "我可是有投資加密貨幣或NFT呢" },
      { count1: 2000, count2: 0, content: "抓緊浪潮！我正在Web3產業！" }
    ]
  },
  {
    number: 5,
    question: "飛向宇宙，浩瀚無垠！哪些領域的「區塊鏈應用」你會覺得有趣？",
    type: "word",
    answers: [
      { count1: 0, count2: 0, content: "虛擬資產投資" },
      { count1: 0, count2: 0, content: "研發技術" },
      { count1: 0, count2: 0, content: "藝文策展、社會創新" },
      { count1: 0, count2: 0, content: "遊戲電競、數位行銷" }
    ]
  },
  {
    number: 6,
    question: "你怎麼看ChatGPT的新浪潮？",
    type: "word",
    answers: [
      { count1: 8, count2: 0, content: "不AI就淘汰！正面迎接新趨勢" },
      { count1: 6, count2: 0, content: "太常胡說八道！還沒很適用" },
      {
        count1: 4,
        count2: 0,
        content: "有點不知所措，擔心工作會不會被AI取代？"
      },
      { count1: 0, count2: 0, content: "觀望中，還沒動手用過" }
    ]
  }
]
